import React, { useEffect } from 'react';
import { useServiceWorker } from '@/hooks/use-service-worker.ts';
import { isPardusBrowser } from '@/components/check-user-agent.tsx';
import '@/styles/service-worker.css';

/**
 * Used for track new versions, statechange
 * @deprecated
 * @constructor
 */
export const ServiceWorkerController: React.FC = () => {
  const { waiting, updateAvailable, registration, updateServiceWorker } = useServiceWorker();
  let reloadTriggered = false;

  const handleUpdate = (): void => {
    if (reloadTriggered) return;
    reloadTriggered = true;

    updateServiceWorker();

    if (isPardusBrowser()) {
      try {
        // @ts-ignore
        if (!window.electronAPI) return;
        // @ts-ignore
        if (window.electronAPI?.reloadPage) {
          // @ts-ignore
          window.electronAPI.reloadPage();
        }
      } catch (error) {
        console.error(error);
      }
    } else {
      if (registration?.waiting) {
        // TODO: This causes infinite reload loop in Safari
        registration.waiting.addEventListener('statechange', (e) => {
          if ((e.target as ServiceWorker).state === 'activated') {
            window.location.reload();
          }
        });
      }
    }
  };

  if (!updateAvailable) return null;

  return (
    <div className="service-worker-update">
      <div className="update-notification">
        <div className="update-content">
          <div className="update-icon">🔄</div>
          <div className="update-text">
            <h4>Доступно обновления</h4>
            <p>Новая версия приложения уже готова. Обновите экран, нажав на F5, чтобы получить доступ к новым функциям.</p>
          </div>
          <div className="update-actions">
            <button
              className="update-button primary"
              onClick={handleUpdate}
            >
              Обновить
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
